import request from '@/utils/server'
// 新增
// export function add(data) {
//     return request({
//       url: '/com/auth/addCooperation',
//       method: 'POST',
//       data: data
//     })
//   }
//   请求列表
export function getStore(query) {
    return request({
      url: '/inventory/getStore',
      method: 'get',
      params: query
    })
  }
  // 导出
export function exports(query) {
    return request({
      url: '/inventory/getStore/export',
      method: 'get',
      params: query
    })
  }
